// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2C8TA","inner":"Footer_inner__uS1OW"};